<template>
    <div class="consultant-profiles-widget">
        <multipane class="custom-resizer" layout="vertical">
            <div class="page-tab-container" :class="{ rightPanelActive: consultant_item }">
                <div class="page-tab">
                    <div class="page-tab-title">
                        Students Profiles ({{ consultants.length }})
                    </div>
                    <div class="page-tab-options row">
                    </div>
                </div>

                <div class="page-body">
                    <div class="table-widget">
                        <table class="table-data">
                            <thead class="table-header">
                                <tr>
                                    <th width="230">Name & Location</th>
                                    <th width="200">Contact</th>
                                    <th v-if="false" width="300">Role</th>
                                    <th width="200">School</th>
                                    <th width="300">Resume</th>
                                    <th width="300">Skills</th>
                                    <th width="80"></th>
                                </tr>
                            </thead>
                            <tbody class="table-body">
                                <template v-for="(item, i) in consultants">
                                    <tr :key="i">
                                        <td>
                                            <widgetProfile :title="item.first_name + ' ' + item.last_name"
                                                :subtitle="item.profile ? item.profile.profile : ''" file_name=""
                                                path="" @click="viewProfile(item)">
                                                >
                                            </widgetProfile>
                                        </td>

                                        <td>
                                            <div class="contact-widget">
                                                <span class="email">{{ item.email }}</span>
                                                <span class="phone" v-if="item.profile">{{ item.profile.phone | validate
                                                    }}</span>
                                            </div>
                                        </td>

                                        <td v-if="false">
                                            <widgetTagsViewer :tags="item.rolesTags" :canDelete="false">
                                            </widgetTagsViewer>
                                        </td>

                                        <td>
                                            {{ item.division ? item.division.name : "" }}
                                        </td>
                                        <td>
                                            <button v-if="item.cvs.length > 0" @click="showStudentCvs(item)"
                                                class="btn-show-cv">
                                                <img src="@/assets/icons/attach-file-gray.svg" />
                                                Resume
                                            </button>
                                        </td>

                                        <td>


                                            <widgetTagsViewer :tags="item.skillTags" :canDelete="false">
                                            </widgetTagsViewer>
                                        </td>

                                        <td>
                                            <widgetButton @click="sendMessage(item)" :loading="false"
                                                class="btn-primary">
                                                Contact
                                            </widgetButton>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>

                        <div class="content-loading-container" v-if="search_loading">
                            <loading :height="20" color="#1ba5a4" :opacity="1" :width="20"
                                :active.sync="account_loading" :is-full-page="false" :can-cancel="false"
                                background-color="#fff" class="loader"></loading>
                        </div>

                        <div v-if="consultants.length == 0 && !search_loading" class="not-found">
                            <widgetNotFoundWidget title="Result not Found" content="No result found for your search">
                                <img class="widget-img" src="@/assets/admin-icon/add-student-icon.svg" />
                            </widgetNotFoundWidget>
                        </div>
                    </div>
                </div>
            </div>
            <multipane-resizer v-if="false && consultant_item"></multipane-resizer>
            <div v-if="false && consultant_item" class="preview-consultant-profile-panel">
                <div class="preview-profile-header">
                    <widgetProfile :title="consultant_item.first_name + ' ' + consultant_item.last_name"
                        :subtitle="consultant_item.profile ? consultant_item.profile.profile : ''" :size="40"
                        file_name="" path="">
                    </widgetProfile>

                    <widgetButton @click="sendMessage(consultant_item)" :loading="false" class="btn-primary">
                        Contact
                    </widgetButton>
                </div>
                <div v-if="consultant_item.cvs.length > 0" class="preview-profile-options">
                    <button class="btn-show-cv">
                        <img src="@/assets/icons/attach-file-gray.svg" />
                        Resume
                    </button>
                </div>
                <div class="preview-profile-contact">
                    <widgetInputWrapper title="Contact">
                        <div class="contact-widget">
                            <span class="email">{{ consultant_item.email }}</span>
                            <span class="phone" v-if="consultant_item.profile">{{ consultant_item.profile.phone
                                }}</span>
                        </div>
                    </widgetInputWrapper>
                </div>
                <div class="skills-widget">
                    <widgetInputWrapper title="Skills">
                        <div class="skills_content__wrapper">
                            <div class="skill_box">
                                <div class="skill_box_header">
                                    <label>Tools</label>
                                </div>
                                <div class="skill_box_body" v-if="consultant_item.skills.tools.length > 0">
                                    <div class="row__item" v-for="(
                                                              value, i
                                                            ) in consultant_item.skills.tools.slice(0, 5)" :key="i">
                                        <span>{{ value.name | validate }}</span>
                                        <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                            :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                </div>
                                <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                        <p>Have not added any tool yet.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="skill_box">
                                <div class="skill_box_header">
                                    <label>Domains</label>
                                </div>
                                <div class="skill_box_body" v-if="consultant_item.skills.domains.length > 0">
                                    <div class="row__item" v-for="(
                                                              value, i
                                                            ) in consultant_item.skills.domains.slice(0, 5)" :key="i">
                                        <span>{{ value.name | validate }}</span>
                                        <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                            :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                </div>
                                <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                        <p>Have not added any domain yet.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="skill_box">
                                <div class="skill_box_header">
                                    <label>Languages</label>
                                </div>
                                <div class="skill_box_body" v-if="consultant_item.skills.languages.length > 0">
                                    <div class="row__item" v-for="(
                                                              value, i
                                                            ) in consultant_item.skills.languages.slice(0, 5)"
                                        :key="i">
                                        <span>{{ value.lang.name | validate }}</span>
                                        <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                            :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                </div>
                                <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                        <p>Have not added any language yet.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="skill_box">
                                <div class="skill_box_header">
                                    <label>Roles</label>
                                </div>
                                <div class="skill_box_body" v-if="consultant_item.skills.roles.length > 0">
                                    <div class="row__item" v-for="(
                                                              value, i
                                                            ) in consultant_item.skills.roles.slice(0, 5)" :key="i">
                                        <span>{{ value.name | validate }}</span>
                                        <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                            :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                </div>
                                <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                        <p>Have not added any role yet.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="next_skills_content__wrapper">
                            <div class="skill_box">
                                <div class="skill_box_header">
                                    <label>Competences</label>
                                </div>
                                <div class="skill_box_body" v-if="consultant_item.skills.competences.length > 0">
                                    <div class="row__item" v-for="(
                                                              value, i
                                                            ) in consultant_item.skills.competences.slice(0, 5)"
                                        :key="i">
                                        <span>{{ value.name | validate }}</span>
                                        <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                            :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                </div>
                                <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                        <p>Have not added any competence yet.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </widgetInputWrapper>
                </div>
            </div>
        </multipane>
    </div>
</template>
<script>
import { eventBus } from "@/main";

export default {
    components: {
    },
    props: {
        form: {
            type: Object,
            default: null
        },
    },
    data: () => ({
        search_loading: false,
        consultant_item: null,
        consultants: []
    }),
    mounted() {
        let vm = this;
        vm.getMatrixUser();
    },
    watch: {
        form: {
            handler: function (val) {
                let vm = this;
                vm.getMatrixUser();
            },
            deep: true
        },
    },
    computed: {

    },
    methods: {
        showStudentCvs(item) {
            let vm = this;
            window.parent.postMessage(
                {
                    message: "parentNewTabNavigate",
                    value: `/crm?path=/resumes?user=${item.id}`,
                },
                "*"
            );
        },
        viewProfile(item) {
            let item_id = window.btoa(item.id);
            let name =
                item.first_name.toLowerCase().replace(/\s/g, "-") +
                "-" +
                item.last_name.toLowerCase().replace(/\s/g, "-") +
                "-" +
                item_id;
            window.parent.postMessage(
                {
                    message: "routeNow",
                    value: {
                        name: "consultant-public-profile",
                        params: { name: name },
                    },
                },
                "*"
            );
        },
        previewConsultantProfile(item) {
            let vm = this;
            vm.consultant_item = item;

        },
        sendMessage(item) {
            let vm = this;
            window.parent.postMessage({ message: "sendMessage", value: item }, "*");
        },
        getMatrixUser() {
            let vm = this;
            vm.$store
                .dispatch("SEARCH_ALL_MATRIX_USER", vm.form)
                .then((responce) => {
                    vm.consultants = vm.processSkills(responce.data);
                    vm.consultants = vm.consultants.map(item => {
                        item.rolesTags = item.roles_copy.map(role => {
                            return {
                                name: role.name,
                                value: role.name
                            }
                        });
                        return item;
                    })

                })
                .catch((error) => {
                    console.error({ error });
                });
        },
        processSkills(consultants) {
            return consultants.map((item) => {
                let skills = {
                    tools: [],
                    domains: [],
                    languages: [],
                    competences: [],
                    roles: [],
                };
                if (item.skills && item.skills.length > 0) {
                    item.skills.forEach((skill) => {
                        skill.tools.forEach((item) => {
                            let obj = {
                                name: item.name,
                                priority: item.priority,
                                level: parseInt(item.priority),
                            };
                            skills.tools.push(obj);
                        });
                        skill.domains.forEach((item) => {
                            let obj = {
                                name: item.name,
                                priority: item.priority,
                                level: parseInt(item.priority),
                            };
                            skills.domains.push(obj);
                        });
                        skill.competences.forEach((item) => {
                            let obj = {
                                name: item.name,
                                priority: item.priority,
                                level: parseInt(item.priority),
                            };
                            skills.competences.push(obj);
                        });
                        skill.roles.forEach((item) => {
                            let obj = {
                                name: item.name,
                                priority: item.priority,
                                level: parseInt(item.priority),
                            };
                            skills.roles.push(obj);
                        });
                        skill.languages.forEach((item) => {
                            if (item.lang) {
                                let obj = {
                                    lang: { name: item.lang.name },
                                    level: parseInt(item.level),
                                };
                                skills.languages.push(obj);
                            }
                        });
                    });
                }
                let skillTags = [];
                skills.tools.forEach((item) => {
                    skillTags.push(item.name);
                });
                skills.domains.forEach((item) => {
                    skillTags.push(item.name);
                });
                skills.competences.forEach((item) => {
                    skillTags.push(item.name);
                });
                skills.roles.forEach((item) => {
                    skillTags.push(item.name);
                });
                skills.languages.forEach((item) => {
                    skillTags.push(item.lang.name);
                });
                eventBus.$set(item, "skillTags", skillTags.map(skillName => {
                    return {
                        name: skillName,
                        value: skillName
                    }
                }));
                eventBus.$set(item, "skills", skills);
                return item;
            });
        },

    },
};
</script>

<style lang="scss" scoped>
.consultant-profiles-widget {
    height: calc(100% - 38px);
    display: flex;

    .custom-resizer {
        height: 100%;

        .multipane-resizer {
            width: 10px !important;

            &::before {
                top: 0px !important;
                height: calc(100% - 20px) !important;
            }
        }

        .page-tab-container {
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            min-width: 40%;
            max-width: 100%;


            .rightPanelActive {
                width: 60% !important;
                min-width: 40% !important;
                max-width: 60% !important;

            }


            .page-tab {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 50px;
                background: #fff;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;

                .page-tab-title {
                    font-family: 'Nunito';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    color: #000;
                    padding-left: 20px;
                }

                .selected-dropdown {
                    position: relative;
                }
            }

            .page-body {
                height: calc(100% - 50px);
                position: relative;
                background: #fff;
                border-bottom-left-radius: 5px;
                border-bottom-right-radius: 5px;

                .table-widget {
                    display: flex;
                    flex-direction: column;
                    padding: 5px;
                    overflow-y: auto;
                    height: 100%;
                    width: 100%;
                    padding-bottom: 100px;

                    .contact-widget {
                        display: flex;
                        flex-direction: column;
                    }

                }
            }
        }

        .preview-consultant-profile-panel {
            height: 100%;
            min-width: 40%;
            width: 40%;
            border-radius: 5px;
            display: flex;
            flex-grow: 1;
            flex-direction: column;
            background: #fff;
            overflow-y: auto;
            padding-bottom: 60px;

            .preview-profile-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 10px;
            }

            .preview-profile-options {
                padding: 20px;
                padding-bottom: 4px;
            }

            .preview-profile-contact {
                padding: 0px 20px;

                .contact-widget {
                    display: flex;
                    flex-direction: column;

                    .email {
                        font-family: 'Nunito';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 13px;
                        color: #464E5F;
                        margin-bottom: 5px;
                    }

                    .phone {
                        font-family: 'Nunito';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 13px;
                        color: #464E5F;
                    }
                }
            }

            .skills-widget {
                margin-top: 5px;
                padding: 10px 20px;

                .skills_content__wrapper {
                    display: grid;
                    grid-template-columns: calc(50% - 5px) calc(50% - 5px);
                    grid-gap: 10px;
                    margin-bottom: 10px;

                    @media (min-width: 300px) and (max-width: 630px) {
                        grid-template-columns: 1fr;
                    }

                    .skill_box {
                        min-width: 0;
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        background: #f3f3f3;
                        border-radius: 10px;

                        .skill_box_header {
                            height: 50px;
                            display: flex;
                            align-items: center;
                            justify-content: space-around;
                            padding: 0px 15px;

                            label {
                                color: #0884af;
                                width: 100%;
                                font-size: 15px;
                            }
                        }

                        .skill_box_body {
                            padding: 0px 15px;

                            .empty-skills {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                min-height: 80px;
                                justify-content: center;

                                p {
                                    text-align: center;
                                    margin-bottom: 20px;
                                    color: #8d8d8d;
                                }

                                button {
                                    width: 133px;
                                    height: 36px;
                                    background: #1890a9 0% 0% no-repeat padding-box;
                                    border-radius: 5px;
                                    color: #fff;
                                }
                            }

                            .row__item {
                                display: flex;
                                margin-bottom: 10px;
                                justify-content: space-between;
                                width: 100%;

                                span {
                                    color: #000000;
                                    font-weight: normal;
                                    margin-top: 2px;
                                    font-size: 12px;
                                    overflow: hidden;
                                    text-decoration: none;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    text-transform: none;
                                }
                            }
                        }
                    }
                }

                .next_skills_content__wrapper {
                    display: grid;
                    grid-template-columns: 1fr;
                    grid-gap: 10px;

                    @media (min-width: 300px) and (max-width: 630px) {
                        grid-template-columns: 1fr;
                    }

                    .skill_box {
                        min-width: 0;
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        background: #f3f3f3;
                        border-radius: 10px;
                        margin-bottom: 15px;

                        .skill_box_header {
                            height: 50px;
                            display: flex;
                            align-items: center;
                            justify-content: space-around;
                            padding: 0px 15px;

                            label {
                                color: #0884af;
                                width: 100%;
                                font-size: 15px;
                            }
                        }

                        .skill_box_body {
                            padding: 0px 15px;

                            .empty-skills {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                min-height: 80px;
                                justify-content: center;

                                p {
                                    text-align: center;
                                    margin-bottom: 20px;
                                    color: #8d8d8d;
                                }

                                button {
                                    width: 133px;
                                    height: 36px;
                                    background: #1890a9 0% 0% no-repeat padding-box;
                                    border-radius: 5px;
                                    color: #fff;
                                }
                            }

                            .row__item {
                                margin-bottom: 10px;
                                display: flex;
                                justify-content: space-between;
                                width: 100%;

                                span {
                                    color: #000000;
                                    font-weight: normal;
                                    margin-top: 2px;
                                    font-size: 12px;
                                    overflow: hidden;
                                    text-decoration: none;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    text-transform: none;
                                }
                            }
                        }
                    }
                }
            }

        }
    }

    .btn-show-cv {
        width: 75px;
        height: 32px;
        background: #f6f6f6;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease-in-out;

        &:hover {
            // animate the button
            transition: all 0.2s ease-in-out;
            transform: scale(1.05);
            box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
        }

        img {
            margin-right: 4px;
        }
    }
}
</style>